module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide-up"
    }
  }, [_c('div', {
    staticClass: "directory",
    class: {
      isComp: _vm.isComp,
      separator: _vm.separator
    },
    style: (("height: " + _vm.height + "%;"))
  }, [(!_vm.isComp) ? _c('div', {
    staticClass: "_top"
  }, [_c('div', {
    staticClass: "_title"
  }, [_c('div', [_vm._v("SMS contact list")]), _vm._v(" "), _c('div', {
    staticClass: "_len"
  }, [_vm._v(_vm._s(_vm.directoryLen) + " people")])]), _vm._v(" "), _c('v-icon', {
    staticClass: "close-icon",
    on: {
      "click": _vm.closeDirectory
    }
  }, [_vm._v("\n        keyboard_arrow_down\n      ")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "_listing"
  }, _vm._l((_vm.directoryLen), function(contact, i) {
    return _c('div', {
      key: i,
      staticClass: "each-contact"
    }, [_c('trackcardsimple', {
      attrs: {
        "item": {},
        "cover": '',
        "title": ("Name " + (i + 1)),
        "subtitle": 'Artist',
        "width": "40",
        "height": "40",
        "round": ""
      }
    })], 1)
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a0d0470","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/mobile/components/contacts/directory.vue
// module id = 1790
// module chunks = 180